module.exports = __webpack_public_path__ + "static/media/back-light.1eecb0e3.svg";